import { Box, Flex, Group, Text } from '@byecode/ui'
import type { PageItem } from '@lighthouse/core'
import React, { useState } from 'react'

import { NO_NAME_PAGE } from '../../constants'
import { TooltipText } from '../TooltipText'
import * as SC from './styles'

interface SelectItemProps {
    data: PageItem
    level?: number
    value?: string
    isShowDesc?: boolean
    initPadding?: number
    onSelect: (v: string) => void
}

export const SelectItem: React.FunctionComponent<SelectItemProps> = ({
    value,
    data,
    initPadding = 20,
    level = 0,
    isShowDesc,
    onSelect
}) => {
    const [opened, setOpened] = useState(true)

    if (data.type === 'COMMON') {
        return (
            <SC.Item
                isHover
                onClick={e => onSelect(data.id)}
                style={{
                    paddingLeft: level * 20 + 22 + initPadding
                    // paddingRight: 0
                }}
            >
                <SC.Wrapper>
                    <Flex style={{ overflow: 'hidden', flex: 1 }} gap={6}>
                        <Box style={{ flex: 1, overflow: 'hidden' }}>
                            <Flex gap={6} style={{ width: '100%', overflow: 'hidden' }}>
                                <SC.Icon type="PageBroadContent" />
                                <TooltipText
                                    title={data.name}
                                    render={ref => (
                                        <Text lineHeight="20px" size={14} ref={ref}>
                                            {data.name || NO_NAME_PAGE}
                                        </Text>
                                    )}
                                />
                            </Flex>
                            {isShowDesc && (
                                <Text
                                    size={12}
                                    style={{ paddingLeft: 22, flexShrink: 0 }}
                                    color="var(--color-gray-500)"
                                    lineHeight="20px"
                                    align="left"
                                >
                                    {data.path}
                                </Text>
                            )}
                        </Box>
                        {value === data.id && <SC.Icon type="Tick" color="var(--color-theme-7)" />}
                    </Flex>
                </SC.Wrapper>
            </SC.Item>
        )
    }

    return (
        <>
            <Group
                opened={opened}
                onCollapseChange={setOpened}
                renderRightIcon={() => null}
                styles={{
                    wrapper: {
                        height: 36,
                        padding: '0!important'
                    },
                    root: {
                        padding: '0!important'
                    },
                    collapse: {
                        padding: '0px'
                    }
                }}
                label={
                    <Flex alignItems="center" gap={4} style={{ paddingLeft: level * 20 + initPadding }} onClick={e => setOpened(!opened)}>
                        {data.type === 'GROUP' && <SC.Icon type={opened ? 'ArrowDownSmall' : 'ArrowRightSmall'} />}
                        <Flex gap={6}>
                            <SC.Icon type="Folder" color="var(--color-theme-7)" />
                            <TooltipText
                                title={data.name}
                                render={ref => (
                                    <Text lineHeight="22px" size={14} weight={400} ref={ref}>
                                        {data.name}
                                    </Text>
                                )}
                            />
                        </Flex>
                    </Flex>
                }
            >
                {data.type === 'GROUP' &&
                    data.children?.map(item => {
                        return (
                            <SelectItem
                                key={item.id}
                                level={level + 1}
                                value={value}
                                data={item}
                                isShowDesc={isShowDesc}
                                initPadding={initPadding}
                                onSelect={onSelect}
                            />
                        )
                    })}
            </Group>
        </>
    )
}
